import { MapTo } from '@adobe/aem-react-editable-components';
import BazaarvoiceReview, { BazaarvoicereviewEditConfig } from './BazaarvoiceReview';

export default MapTo('cob-corp-acquisition/components/creditonebank/bazaarvoicereview')(BazaarvoiceReview, BazaarvoicereviewEditConfig);